import { useTypedQuery } from '../lib/generated/zeus/apollo';
import { userSelector } from './selectors/user';
import { activeRecord } from '../lib/graphql/common/queries';
import { genericScalars } from '../lib/graphql/helpers';

/**
 * Optional arguments to modify the {@link useQueryUsersByIds} query.
 */
type UseQueryUsersByIdsOptions = {
  /**
   * When set to true, the query will return users
   * that are "soft deleted" (record_status = "Deleted"),
   * rather than the default behaviour of ignoring those records.
   */
  readonly allowInactiveUsers: boolean;
};

/**
 * Query users by providing users' id.
 * @param userIds an array contains set of user id, or single user id.
 * @param options optional arguments to modify the query
 * @returns set of users that matched the query.
 */
const useQueryUsersByIds = (
  userIds: readonly string[] | string,
  options: UseQueryUsersByIdsOptions = {
    allowInactiveUsers: false,
  }
) =>
  useTypedQuery(
    {
      user: [
        {
          where: {
            ...(options.allowInactiveUsers ? {} : activeRecord),
            id: {
              _in: typeof userIds === 'string' ? [userIds] : [...userIds],
            },
          },
        },
        userSelector,
      ],
    },
    {
      scalars: genericScalars,
    }
  );

export default useQueryUsersByIds;
